import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDashboardStats } from '../../services/adminMarketplaceService';

const StatCard = ({ label, value, onClick, alert }) => (
  <button
    onClick={onClick}
    disabled={!onClick}
    className={`text-left bg-white p-4 rounded-lg shadow ${onClick ? 'hover:shadow-md cursor-pointer' : 'cursor-default'} ${alert ? 'border-2 border-red-300' : ''}`}
  >
    <p className="text-sm text-gray-500">{label}</p>
    <p className={`text-2xl font-bold ${alert ? 'text-red-600' : ''}`}>{value}</p>
  </button>
);

const DashboardOverview = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    getDashboardStats().then(setStats);
  }, []);

  if (!stats) return <p>Loading...</p>;

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-bold">Overview</h2>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatCard label="Pending therapist verifications" value={stats.pendingTherapists}
          onClick={() => navigate('/admin/therapist-verification')} alert={stats.pendingTherapists > 0} />
        <StatCard label="Pending venue verifications" value={stats.pendingVenues}
          onClick={() => navigate('/admin/venue-verification')} alert={stats.pendingVenues > 0} />
        <StatCard label="Open disputes" value={stats.openDisputes}
          onClick={() => navigate('/admin/disputes')} alert={stats.openDisputes > 0} />
        <StatCard label="Flagged safety reports" value={stats.flaggedRatings}
          onClick={() => navigate('/admin/flagged-reports')} alert={stats.flaggedRatings > 0} />
        <StatCard label="Pending withdrawals" value={`${stats.pendingWithdrawalCount} (₦${stats.pendingWithdrawalTotal.toLocaleString()})`}
          onClick={() => navigate('/admin/withdrawals')} alert={stats.pendingWithdrawalCount > 0} />
        <StatCard label="Active orders" value={stats.activeOrders}
          onClick={() => navigate('/admin/marketplace-orders')} />
        <StatCard label="Completed orders" value={stats.completedOrderCount} />
        <StatCard label="Platform revenue (completed)" value={`₦${stats.platformRevenue.toLocaleString()}`} />
        <StatCard label="Banned users" value={stats.bannedUsers}
          onClick={() => navigate('/admin/users')} />
      </div>
    </div>
  );
};

export default DashboardOverview;
